import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType } from "__generated__/graphql";
import StaffelCalculationMethodForm from "view/calculationmethods/components/form/StaffelCalculationMethodForm";
import StaffelCalculationMethodDetails from "view/calculationmethods/components/details/StaffelCalculationMethodDetails";

export const StaffelSchema: RegistryItem = {
	[CalculationMethodType.Staffel]: {
		Form: StaffelCalculationMethodForm,
		Details: StaffelCalculationMethodDetails,
		fields: {
			"calculationMethod.staffel": { path: "staffel", rules: { required: true } },
		},
		toInput: (form) => ({
			staffelCalculationMethodInput: {
				id: form.id,
				staffelUnit: form.staffelUnit,
				staffelItem: form.staffelItem?.id,
				staffel: form.staffel?.id,
			},
		}),
		toForm: (method) => ({
			staffelUnit: method.staffelUnit ?? undefined,
			staffel: method.staffel ? {
				id: method.staffel.id,
				description: method.staffel.description ?? undefined,
				discriminator: method.staffel.discriminator,
				staffelItems: method.staffel.staffelItems ?? [],
			} : undefined,
			staffelItem: method.staffelItem ?? undefined,
		}),
	},
};
